module.exports = __webpack_public_path__ + "img/1B.f9c61a29.jpg";